import React, { useEffect, useRef, useState } from 'react';
import InputGroup from 'react-bootstrap/InputGroup';
import { Card, Row, Col, Button, Form } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useAuth } from 'nursd-dashboard/context/AuthContext';
import {
  getAllFacilityOrgList,
  getAllNurseOrgList,
  getOrganizationDetails
} from 'nursd-dashboard/api/organizationTable';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { createNurse } from 'nursd-dashboard/api/nurseTable';
import { postFacilityNotification } from 'nursd-dashboard/api/facilityNotification';
import { socket } from 'nursd-dashboard/api/socket';
import { sendNotification } from 'nursd-dashboard/api/webNotification';
import makeAnimated from 'react-select/animated';
import Select from 'react-select';
import Flex from 'components/common/Flex';
import {
  optionsEMR,
  optionsSkill,
  optionsSpecialty
} from 'nursd-dashboard/data/defaultData';
import { Link } from 'react-router-dom';
import paths from 'routes/paths';
import {
  formatPhoneNumber,
  removeFormatting
} from 'nursd-dashboard/utils/function';

const GOOGLE_PLACES_API_KEY = 'AIzaSyASXZSrsvL25WiY7nZc2M4WJhkDMj-jkvs';
const mapApiJs = 'https://maps.googleapis.com/maps/api/js';

function loadAsyncScript(src) {
  return new Promise(resolve => {
    const script = document.createElement('script');
    Object.assign(script, {
      type: 'text/javascript',
      async: true,
      src
    });
    script.addEventListener('load', () => resolve(script));
    document.head.appendChild(script);
  });
}

const extractAddress = place => {
  const address = {
    street_number: '',
    route: '',
    locality: '',
    administrative_area_level_3: '',
    administrative_area_level_2: '',
    administrative_area_level_1: '',
    country: '',
    postal_code: '',
    postal_code_suffix: '',
    latitude: '',
    longitude: '',
    plain() {
      const street_number = this.street_number ? this.street_number + ', ' : '';
      const route = this.route ? this.route + ', ' : '';
      const locality = this.locality ? this.locality + ', ' : '';
      const administrative_area_level_3 = this.administrative_area_level_3
        ? this.administrative_area_level_3 + ', '
        : '';
      const administrative_area_level_2 = this.administrative_area_level_2
        ? this.administrative_area_level_2 + ', '
        : '';
      const administrative_area_level_1 = this.administrative_area_level_1
        ? this.administrative_area_level_1 + ', '
        : '';
      const country = this.country ? this.country + ', ' : '';
      const postal_code = this.postal_code ? this.postal_code + ', ' : '';
      const postal_code_suffix = this.postal_code_suffix
        ? this.postal_code_suffix + ', '
        : '';
      return (
        street_number +
        route +
        locality +
        administrative_area_level_3 +
        administrative_area_level_2 +
        administrative_area_level_1 +
        country +
        postal_code +
        postal_code_suffix
      );
    }
  };

  if (!Array.isArray(place?.address_components)) {
    return address;
  }

  place.address_components.forEach(component => {
    const types = component.types;
    const value = component.long_name;

    if (types.includes('street_number')) {
      address.street_number = value;
    }
    if (types.includes('route')) {
      address.route = value;
    }
    if (types.includes('locality')) {
      address.locality = value;
    }
    if (types.includes('administrative_area_level_3')) {
      address.administrative_area_level_3 = value;
    }
    if (types.includes('administrative_area_level_2')) {
      address.administrative_area_level_2 = value;
    }
    if (types.includes('administrative_area_level_1')) {
      address.administrative_area_level_1 = value;
    }
    if (types.includes('country')) {
      address.country = value;
    }
    if (types.includes('postal_code')) {
      address.postal_code = value;
    }
    if (types.includes('postal_code_suffix')) {
      address.postal_code_suffix = value;
    }
  });

  let points = Object.keys(place?.geometry?.viewport);

  address.latitude = place?.geometry?.viewport?.[points[0]]?.lo;
  address.longitude = place?.geometry?.viewport?.[points[1]]?.lo;

  return address;
};

function Create_nurse() {
  const navigate = useNavigate();
  // Get the current date
  const currentDate = new Date();

  // Subtract 18 years from the current date
  const date18YearsAgo = new Date(
    currentDate.getFullYear() - 18,
    currentDate.getMonth(),
    currentDate.getDate()
  );

  const [valueSpecialty, setValueSpecialty] = useState(null);
  const [valueSkill, setValueSkill] = useState(null);
  const [valueEMR, setValueEMR] = useState(null);
  const [moreOptions, setMoreOptions] = useState(false);
  const animatedComponents = makeAnimated();

  const [newNurse, setNewNurse] = useState({
    email: '',
    firstName: '',
    lastName: '',
    password: '',
    phoneNumber: '',
    gender: '',
    dateOfBirth: date18YearsAgo,
    primaryState: '',
    fullAddress: '',
    latitude: '',
    longitude: '',
    organization: '',
    location_id: '',
    primaryLicenseType: '',
    primaryLicenseMultiPrivilege: false,
    clinicalLicenseNumber: '',
    clinicalLicenseExpirationDate: new Date(),
    nurseVerified: true,
    emailVerified: true,
    poolType: 'Internal Pool'
  });

  const searchInput = useRef(null);

  const initMapScript = () => {
    if (window.google) {
      return Promise.resolve();
    }
    const src = `${mapApiJs}?key=${GOOGLE_PLACES_API_KEY}&libraries=places&v=weekly`;
    return loadAsyncScript(src);
  };

  const onChangeAddress = autocomplete => {
    const place = autocomplete.getPlace();
    handleInputChangeNewData({
      target: {
        name: 'fullAddress',
        value:
          extractAddress(place)?.street_number +
          ', ' +
          extractAddress(place)?.route +
          ', ' +
          extractAddress(place)?.locality +
          ', ' +
          extractAddress(place)?.administrative_area_level_3 +
          ', ' +
          extractAddress(place)?.administrative_area_level_2 +
          ', ' +
          extractAddress(place)?.administrative_area_level_1 +
          ', ' +
          extractAddress(place)?.country +
          ', ' +
          extractAddress(place)?.postal_code +
          ', ' +
          extractAddress(place)?.postal_code_suffix
      }
    });
    handleInputChangeNewData({
      target: {
        name: 'latitude',
        value: extractAddress(place)?.latitude
      }
    });
    handleInputChangeNewData({
      target: {
        name: 'longitude',
        value: extractAddress(place)?.longitude
      }
    });
    handleInputChangeNewData({
      target: {
        name: 'city',
        value: extractAddress(place)?.locality
      }
    });
    handleInputChangeNewData({
      target: {
        name: 'state',
        value: extractAddress(place)?.administrative_area_level_1
      }
    });
    handleInputChangeNewData({
      target: {
        name: 'zipCode',
        value: extractAddress(place)?.postal_code
      }
    });
  };

  const initAutocomplete = () => {
    if (!searchInput.current) return;

    const autocomplete = new window.google.maps.places.Autocomplete(
      searchInput.current
    );
    autocomplete.setFields(['address_component', 'geometry']);
    autocomplete.addListener('place_changed', () =>
      onChangeAddress(autocomplete)
    );
  };

  useEffect(() => {
    initMapScript().then(() => initAutocomplete());
  }, []);

  const [options] = useState(['Male', 'Female', 'Others']);
  const [optionsLicense] = useState(['LPN', 'CNA', 'HHA', 'RN']);

  const [validated, setValidated] = useState(false);
  const [loading, setLoading] = useState(false);
  const [orgLocationIdData, setOrgLocationIdData] = useState([]);
  const [orgLocationIdAddress, setOrgLocationIdAddress] = useState([]);
  const { authToken, location, organization, userId } = useAuth();

  const getNurse = async () => {
    try {
      const facilityList = await getAllNurseOrgList(
        authToken,
        location,
        organization
      );

      const list = facilityList.sort((a, b) =>
        a.firstName.toLowerCase().localeCompare(b.firstName.toLowerCase())
      );
      setOrgLocationIdData(list);
    } catch (error) {
      console.log(error);
      setOrgLocationIdData([]);
    }
  };

  const getOrgLocationList = async () => {
    await getOrganizationDetails(authToken, userId)
      .then(res => {
        let arrState = [];
        if (res) {
          res?.locations.map(i =>
            arrState.push({
              location: i.location_id,
              state: i.location_state
            })
          );
          if (res?.locations.length === arrState.length) {
            setOrgLocationIdAddress(arrState);
          }
        }
      })
      .catch(e => {
        console.log(e);
      });
  };

  useEffect(() => {
    if (location !== '') {
      getNurse();
      getOrgLocationList();
    }
  }, [authToken, location]);

  const dataCheck = !orgLocationIdData.some(serverItem => {
    return (
      serverItem.email === newNurse.email ||
      serverItem.phoneNumber === newNurse.phoneNumber
    );
  });

  const handleInputChangeNewData = event => {
    setNewNurse(prevState => {
      return { ...prevState, [event.target.name]: event.target.value };
    });
  };

  const postNurse = async () => {
    setLoading(true);
    if (dataCheck) {
      let state = orgLocationIdAddress?.find(i => i?.location === location);
      try {
        await createNurse(authToken, {
          email: newNurse?.email,
          firstName: newNurse?.firstName,
          lastName: newNurse?.lastName,
          password: newNurse?.password,
          phoneNumber: removeFormatting(newNurse?.phoneNumber),
          gender: newNurse?.gender,
          dateOfBirth: newNurse?.dateOfBirth,
          primaryState: state?.state,
          fullAddress: newNurse?.fullAddress,
          latitude: newNurse?.latitude.toString(),
          longitude: newNurse?.longitude.toString(),
          location_id: location,
          organization: organization,
          primaryLicenseType: newNurse?.primaryLicenseType,
          primaryLicenseMultiPrivilege: newNurse?.primaryLicenseMultiPrivilege,
          clinicalLicenseNumber: newNurse?.clinicalLicenseNumber,
          clinicalLicenseExpirationDate:
            newNurse?.clinicalLicenseExpirationDate,
          nurseVerified: newNurse?.emailVerified,
          emailVerified: newNurse?.emailVerified,
          poolType: newNurse?.poolType
        })
          .then(res => {
            toast.success(
              `${res?.firstName + ' ' + res?.lastName} created successfully.`,
              {
                theme: 'colored'
              }
            );
            getAllFacilityOrgList(authToken, location, organization)
              .then(async facilitiesData => {
                for (const facility of facilitiesData) {
                  if (Number(facility?.id) !== Number(res?.id)) {
                    try {
                      await postFacilityNotification(
                        authToken,
                        facility?.id,
                        '',
                        'New employee joined!',
                        `${
                          res?.firstName + ' ' + res?.lastName
                        } has been added as a new employee to your location.`,
                        'ManageUser',
                        {},
                        false,
                        false,
                        'green',
                        ''
                      );
                      socket?.emit('tableNotificationInsert', {
                        table: 'FacilityNotificationTable',
                        id: facility?.id
                      });
                      if (facility?.mobileId) {
                        sendNotification(authToken, {
                          expoPushToken: facility?.mobileId,
                          title: 'New employee joined!',
                          body: `${
                            res?.firstName + ' ' + res?.lastName
                          } has been added as a new employee to your location.`,
                          data: { screen: 'ManageUser' }
                        });
                      }
                    } catch (error) {
                      console.error('Error fetching facility detail:', error);
                    }
                  }
                }
              })
              .catch(error => console.error('Fetching facility:', error));
            setNewNurse({
              email: '', //
              firstName: '', //
              lastName: '', //
              password: '', //
              phoneNumber: '', //
              gender: '', //
              dateOfBirth: date18YearsAgo, //
              primaryState: '', //
              fullAddress: '',
              latitude: '',
              longitude: '',
              organization: '', //
              location_id: '', //
              primaryLicenseType: '', //
              primaryLicenseMultiPrivilege: false, //
              clinicalLicenseNumber: '', //
              clinicalLicenseExpirationDate: new Date(), //
              nurseVerified: false, //
              emailVerified: false //,
            });
            setLoading(false);
            navigate(paths.nursd_nurse);
          })
          .catch(e => {
            setLoading(false);
            toast.error(e?.toString(), {
              theme: 'colored'
            });
            // console.log(e);
          });
      } catch (error) {
        console.log('data save error:', error);
      }
    } else {
      setLoading(false);
      toast.error(
        `${
          newNurse?.firstName + ' ' + newNurse?.lastName
        } record already stored in database!`,
        {
          theme: 'colored'
        }
      );
    }
  };

  const handleSubmit = event => {
    event.preventDefault(); // Prevent default form submission behavior

    const form = event.currentTarget;
    // console.log(form.checkValidity());
    if (form.checkValidity() === false) {
      event.stopPropagation();
      setValidated(true);
      return;
    }

    postNurse();
  };

  return (
    <Card>
      <Card.Header>
        <h5 className="mb-0">Create Nurse - {location}</h5>
      </Card.Header>
      <Card.Body>
        <Form
          noValidate
          validated={validated}
          onSubmit={loading ? null : handleSubmit}
        >
          <Row className="mb-3">
            <Form.Group as={Col} md="4" controlId="FirstName">
              <Form.Label>First name</Form.Label>
              <Form.Control
                required
                type="text"
                placeholder="First name"
                name="firstName"
                value={newNurse.firstName}
                onChange={handleInputChangeNewData}
              />
              <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
              <Form.Control.Feedback type="invalid">
                Please enter a first name.
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group as={Col} md="4" controlId="LastName">
              <Form.Label>Last name</Form.Label>
              <Form.Control
                required
                type="text"
                placeholder="Last name"
                name="lastName"
                value={newNurse.lastName}
                onChange={handleInputChangeNewData}
              />
              <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
              <Form.Control.Feedback type="invalid">
                Please enter a last name.
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group as={Col} md="4" controlId="Email">
              <Form.Label>Email</Form.Label>
              <InputGroup hasValidation>
                <InputGroup.Text id="inputGroupPrepend">@</InputGroup.Text>
                <Form.Control
                  type="text"
                  placeholder="Email"
                  aria-describedby="inputGroupPrepend"
                  required
                  name="email"
                  value={newNurse.email}
                  onChange={handleInputChangeNewData}
                />
                <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                <Form.Control.Feedback type="invalid">
                  Please enter a email.
                </Form.Control.Feedback>
              </InputGroup>
            </Form.Group>
          </Row>
          <Row className="mb-3">
            <Form.Group as={Col} md="4" controlId="DateOfBirth">
              <Form.Label>Date Of Birth</Form.Label>
              <DatePicker
                popperPlacement="bottom-start"
                selected={newNurse.dateOfBirth}
                onChange={date =>
                  setNewNurse(prevState => {
                    return { ...prevState, dateOfBirth: date };
                  })
                }
                formatWeekDay={day => day.slice(0, 3)}
                className="form-control"
                placeholderText="Select Date"
              />
            </Form.Group>
            <Form.Group as={Col} md="4" controlId="Gender">
              <Form.Label>Gender</Form.Label>
              <Form.Select
                onChange={e =>
                  setNewNurse(prevState => {
                    return { ...prevState, gender: e.target.value };
                  })
                }
                size="sm"
                required
              >
                <option value="">Select Gender</option>
                {options.map(option => (
                  <option key={option}>{option}</option>
                ))}
              </Form.Select>
              <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
              <Form.Control.Feedback type="invalid">
                Please choose a gender.
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group as={Col} md="4" controlId="PhoneNumber">
              <Form.Label>Phone Number</Form.Label>
              <Form.Control
                required
                type="text"
                placeholder="Phone Number"
                name="phoneNumber"
                value={formatPhoneNumber(newNurse.phoneNumber)}
                onChange={handleInputChangeNewData}
                // pattern="[0-9]*"
              />
              <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
              <Form.Control.Feedback type="invalid">
                Please enter a phone number.
              </Form.Control.Feedback>
            </Form.Group>
          </Row>
          <Row className="mb-3">
            <Form.Group as={Col} md="4" controlId="PrimaryLicenseType">
              <Form.Label>Primary LicenseType</Form.Label>
              <Form.Select
                onChange={e =>
                  setNewNurse(prevState => {
                    return { ...prevState, primaryLicenseType: e.target.value };
                  })
                }
                size="sm"
                required
              >
                <option value="">Select LicenseType</option>
                {optionsLicense.map(option => (
                  <option key={option}>{option}</option>
                ))}
              </Form.Select>
              <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
              <Form.Control.Feedback type="invalid">
                Please choose a license type.
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group
              as={Col}
              md="4"
              controlId="primaryLicenseMultiPrivilege"
            >
              <Form.Label></Form.Label>
              <Form.Check
                type="checkbox"
                id="primaryLicenseMultiPrivilege"
                label="Primary LicenseMulti Privilege"
                className="mt-2"
                checked={newNurse.primaryLicenseMultiPrivilege}
                onChange={() =>
                  handleInputChangeNewData({
                    target: {
                      name: 'primaryLicenseMultiPrivilege',
                      value: !newNurse.primaryLicenseMultiPrivilege
                    }
                  })
                }
              />
            </Form.Group>
            <Form.Group as={Col} md="4" controlId="FullAddress">
              <Form.Label>Full Address</Form.Label>
              <Form.Control
                required
                ref={searchInput}
                contentEditable={false}
                type="text"
                placeholder="Full Address"
                value={newNurse?.fullAddress}
                name="fullAddress"
                onChange={handleInputChangeNewData}
              />
              <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
              <Form.Control.Feedback type="invalid">
                Please choose a full address.
              </Form.Control.Feedback>
            </Form.Group>
          </Row>
          <Row className="mb-3">
            <Form.Group as={Col} md="4" controlId="ClinicalLicenseNumber">
              <Form.Label>Clinical License Number</Form.Label>
              <Form.Control
                required
                type="text"
                placeholder="Clinical License Number"
                name="clinicalLicenseNumber"
                value={newNurse.clinicalLicenseNumber}
                onChange={handleInputChangeNewData}
                // pattern="[0-9]*"
              />
              <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
              <Form.Control.Feedback type="invalid">
                Please enter a clinical license number.
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group
              as={Col}
              md="4"
              controlId="clinicalLicenseExpirationDate"
            >
              <Form.Label>Clinical License Expiration Date</Form.Label>
              <DatePicker
                popperPlacement="bottom-start"
                selected={newNurse.clinicalLicenseExpirationDate}
                onChange={date =>
                  setNewNurse(prevState => {
                    return {
                      ...prevState,
                      clinicalLicenseExpirationDate: date
                    };
                  })
                }
                formatWeekDay={day => day.slice(0, 3)}
                className="form-control"
                placeholderText="Select Date"
              />
            </Form.Group>
            <Form.Group as={Col} md="4" controlId="Password">
              <Form.Label>Password</Form.Label>
              <Form.Control
                required
                type="text"
                placeholder="Password"
                name="password"
                value={newNurse.password}
                onChange={handleInputChangeNewData}
              />
              <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
              <Form.Control.Feedback type="invalid">
                Please enter a password.
              </Form.Control.Feedback>
            </Form.Group>
          </Row>
          {moreOptions && (
            <Row className="mb-3">
              <Form.Group as={Col} md="4" className="mb-2" controlId="License">
                <Form.Label className="fs-9">Select Specialty</Form.Label>
                <Select
                  closeMenuOnSelect={false}
                  options={optionsSpecialty}
                  placeholder="Select..."
                  isMulti
                  classNamePrefix="react-select"
                  value={valueSpecialty}
                  onChange={value => {
                    setValueSpecialty(value);
                  }}
                  components={animatedComponents}
                  required
                />
              </Form.Group>
              <Form.Group as={Col} md="4" className="mb-2" controlId="License">
                <Form.Label className="fs-9">Select Skills</Form.Label>
                <Select
                  closeMenuOnSelect={false}
                  options={optionsSkill}
                  placeholder="Select..."
                  isMulti
                  classNamePrefix="react-select"
                  value={valueSkill}
                  onChange={value => {
                    setValueSkill(value);
                  }}
                  components={animatedComponents}
                  required
                />
              </Form.Group>
              <Form.Group as={Col} md="4" className="mb-2" controlId="License">
                <Form.Label className="fs-9">
                  Select EMR/EHR Experience
                </Form.Label>
                <Select
                  closeMenuOnSelect={false}
                  options={optionsEMR}
                  placeholder="Select..."
                  isMulti
                  classNamePrefix="react-select"
                  value={valueEMR}
                  onChange={value => {
                    setValueEMR(value);
                  }}
                  components={animatedComponents}
                  required
                />
              </Form.Group>
            </Row>
          )}
          <Row>
            <Form.Group as={Col} md="4" controlId="emailVerified">
              <Form.Check
                type="checkbox"
                id="emailVerified"
                label="OTP Verification"
                className="mt-2"
                checked={!newNurse.emailVerified}
                onChange={() =>
                  handleInputChangeNewData({
                    target: {
                      name: 'emailVerified',
                      value: !newNurse.emailVerified
                    }
                  })
                }
              />
            </Form.Group>
            <Form.Group as={Col} md="4" controlId="Internal">
              <Form.Check
                type="checkbox"
                id="Internal"
                label="Internal Pool"
                className="mt-2"
                checked={newNurse.poolType === 'Internal Pool'}
                onChange={() =>
                  handleInputChangeNewData({
                    target: {
                      name: 'poolType',
                      value: 'Internal Pool'
                    }
                  })
                }
              />
            </Form.Group>
            <Form.Group as={Col} md="4" controlId="Float">
              <Form.Check
                type="checkbox"
                id="Float"
                label="Float Pool"
                className="mt-2"
                checked={newNurse.poolType === 'Float Pool'}
                onChange={() =>
                  handleInputChangeNewData({
                    target: {
                      name: 'poolType',
                      value: 'Float Pool'
                    }
                  })
                }
              />
            </Form.Group>
          </Row>
          <Flex className="mt-2">
            <Button type="submit">
              {loading ? 'Loading...' : 'Create Nurse'}
            </Button>
            <Button
              as={Link}
              to={paths.nursd_nurse}
              variant="secondary"
              className="mx-2"
            >
              Cancel
            </Button>
            <Button
              variant="link"
              onClick={() => setMoreOptions(!moreOptions)}
              className="px-4 mx-0 text-dark"
            >
              {moreOptions ? 'Hide' : 'More'} options
            </Button>
          </Flex>
        </Form>
      </Card.Body>
    </Card>
  );
}

export default Create_nurse;
